// extracted by mini-css-extract-plugin
export default {"etfPerformanceChartContainer":"SnapshotPerformanceChart_etfPerformanceChartContainer__7Sy0s","topDivider":"SnapshotPerformanceChart_topDivider__vPXWC"};